import Dexie from 'dexie';

export interface Blob2 {
  buffer: ArrayBuffer | string;
  type: string;
}

export interface FileAttachment {
  id: string;
  content: Blob;
}

export interface ChangeLogEvent {
  id?: number;
  key: string;
  type: string;
  status: string;
  retryCount?: number;
  rejectionCode?: 'INVALID_CHANGE_CONTENT' | 'INVALID_CHANGE_ENVELOPE' | 'CHANGE_REJECTED';
  rejectionMessage?: string;
  content: any;
  refs: string[];
  created: number;
  updated: number;
  attachments?: FileAttachment[];
}

export class ChangeLogDb {
  events: Dexie.Table<ChangeLogEvent, number>;

  constructor() {
    const db = new Dexie('change-log');
    db.version(1).stores({ events: '++id,key,type,status,refs' });
    this.events = db.table('events');
  }
}
